// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero_wrapper__XGNC0","bg":"Hero_bg__rlCKY","linear-box":"Hero_linear-box__Tecy4","heading":"Hero_heading__09X6F"};